import { useMemo } from 'react';

import { FormContextValues, useFormController } from '@dreryk/react-common';

import { PriceChangeReasonField } from '../../../shared/priceChangeReason/PriceChangeReasonField';

export type VisitSettlementPriceChangeReasonFormBean = {
   priceChangeReason: string | null;
};

export type VisitSettlementPriceChangeReasonFormInitializer = () => VisitSettlementPriceChangeReasonFormBean;

export type VisitSettlementPriceChangeReasonFormController = FormContextValues<VisitSettlementPriceChangeReasonFormBean>;

type VisitSettlementPriceChangeReasonFormRendererProps = Pick<
   VisitSettlementPriceChangeReasonFormController,
   'handleSubmit' | 'formState'
>;

type VisitSettlementPriceChangeReasonFormRenderer = (
   renderProps: VisitSettlementPriceChangeReasonFormRendererProps
) => JSX.Element;

type VisitSettlementPriceChangeReasonFormProps = {
   readonly children: VisitSettlementPriceChangeReasonFormRenderer;
   readonly initializer: VisitSettlementPriceChangeReasonFormInitializer;
};

export const VisitSettlementPriceChangeReasonForm = (props: VisitSettlementPriceChangeReasonFormProps): JSX.Element => {
   const { register, handleSubmit, formState } = useFormController<VisitSettlementPriceChangeReasonFormBean>(
      // eslint-disable-next-line react-hooks/exhaustive-deps
      useMemo(() => props.initializer(), [props.initializer])
   );

   return (
      <>
         <form noValidate autoComplete={'off'}>
            <PriceChangeReasonField name={'priceChangeReason'} register={register} />
         </form>

         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
         })}
      </>
   );
};
